// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3B4nv","rootSmall":"AddTileButton_rootSmall__1u4Go"};